import { Component } from '@angular/core';

@Component({
  selector: 'app-home-layout',
  template: `
    <div class="wrapper">
  <app-header></app-header>
  <app-sidebar></app-sidebar>
<ng4-loading-spinner> </ng4-loading-spinner>
  <div>
    <p-messages [(value)]="msgs"></p-messages>
    <router-outlet></router-outlet>
  </div>
</div>
  `,
  styles: []
})
export class HomeLayoutComponent { }



// WEBPACK FOOTER //
// ./src/app/components/layouts/main.layout.ts